import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as r, normalizeClass as n, createElementVNode as s } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconSatisfiedFilled",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function f(e, t, l, u, _, a) {
  return d(), r("svg", {
    "aria-label": l.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--satisfied-filled"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Satisfied Filled",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    s("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.438 6A5.437 5.437 0 1 0 .563 6a5.437 5.437 0 0 0 10.874 0Zm-3.5-1.5a.438.438 0 0 0-.438-.438h-.005a.437.437 0 1 0 0 .875H7.5a.437.437 0 0 0 .438-.437Zm-3 0a.438.438 0 0 0-.438-.438h-.005a.437.437 0 1 0 0 .875H4.5a.437.437 0 0 0 .438-.437ZM7.65 6.737l.001-.001-.003.004a2.535 2.535 0 0 1-.437.407A2.057 2.057 0 0 1 6 7.562c-.504 0-.916-.202-1.211-.417a2.536 2.536 0 0 1-.437-.406l-.003-.004v.001m3.302-.001a.438.438 0 0 1 .699.527L8 7l.35.263h-.001l-.001.002-.004.005-.01.013a1.935 1.935 0 0 1-.155.176 3.41 3.41 0 0 1-.453.395A2.93 2.93 0 0 1 6 8.437a2.931 2.931 0 0 1-1.726-.583 3.41 3.41 0 0 1-.608-.571l-.01-.013-.004-.005-.001-.001S3.65 7.261 4 7l-.35.263a.437.437 0 0 1 .699-.527m3.301.001.001-.001Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const v = /* @__PURE__ */ o(c, [["render", f]]);
export {
  v as default
};
//# sourceMappingURL=satisfied-filled.js.map
